<div
	*ngIf="editInfoMode"
	class="overlay bg-black opacity-30 fixed top-0 left-0 w-screen h-screen z-30"
></div>
<div
	*ngIf="type == 2"
	class="bg-[#222433] rounded-12px p-24px flex justify-between items-center"
>
	<div>
		<h1 class="text-[18px] text-gradient font-DIN-bold font-bold mb-6px">
			{{ 'STORE.STORE_PROFILE.STORE_ACTIVATION' | translate }}
		</h1>
		<p class="text-off-white text-font-14">
			{{ 'STORE.STORE_PROFILE.COMPLETE_STORE_DATA' | translate }}
		</p>
	</div>

	<div class="flex">
		<p class="text-[#F2B8B5] mx-6px">
			{{ 'STORE.STORE_PROFILE.STORE_INACTIVE' | translate }}
		</p>
		<p class="text-success-green mx-6px">
			{{ 'STORE.STORE_PROFILE.STORE_ACTIVE' | translate }}
		</p>
		<mat-slide-toggle (change)="changeStoreStatus($event)"></mat-slide-toggle>
	</div>
</div>

<div>
	<div class="flex flex-row justify-between mt-4 min-h-[40px]">
		<p class="text-[#1C252E] font-medium text-base leading-5 m-0">
			{{ 'ORGANIZATION.BRANCH.BASIC_INFORMATION' | translate }}
		</p>
		<div
			*ngIf="!editInfoMode"
			class="flex gap-1 ltr:mr-6 rtl:ml-6 hover:cursor-pointer"
		>
			<img class="w-5 max-h-5" src="assets/images/edit-blue.svg" alt="" />
			<p (click)="changeEditMode()" class="text-[#009EF7]">
				{{ 'ACTIONS.EDIT' | translate }}
			</p>
		</div>
	</div>
	<div
		class="flex flex-col custom-shadow p-24px gap-[14px] rounded-12px bg-off-white lg:w-[776px] {{
			editInfoMode ? 'z-40' : ''
		}} relative  "
	>
		<form [formGroup]="basicInfoForm">
			<!-- branch name -->
			<mat-form-field
				*ngIf="editInfoMode"
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full"
				appearance="outline"
			>
				<mat-label
					>{{ 'ORGANIZATION.BRANCH.BRANCH_NAME' | translate }}
				</mat-label>
				<input
					(keyup)="changeBranchName()"
					type="text"
					formControlName="name"
					matInput
					placeholder="{{ 'ORGANIZATION.BRANCH.BRANCH_NAME' | translate }}"
					maxlength="150"
					minlength="2"
					class=""
					[ngClass]="!editInfoMode ? 'text-[#6E7191]' : 'text-[#4E4B66]'"
				/>
				<img
					*ngIf="getController('name')?.value && editInfoMode"
					(click)="getController('name').setValue('')"
					class="cursor-pointer absolute ltr:right-3 rtl:left-3 top-[15px] inline-block"
					(click)="getController('name')?.setValue('')"
					class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
					src="./assets/images/close-square.svg"
					alt=""
				/>

				<mat-error>
					<validation-message
						[controller]="getController('name')"
						controller_name="ORGANIZATION.BRANCH.BRANCH_NAME"
						pattern_Message=""
					>
					</validation-message>
				</mat-error>
				<mat-error *ngIf="!isDataValid && editInfoMode">
					<small class="mb-3 whitespace-nowrap text-font-12">{{
						nameError
					}}</small>
				</mat-error>
			</mat-form-field>

			<div
				*ngIf="!editInfoMode"
				class="w-full h-[73px] p-[17px] border-solid border-b-2"
			>
				<p class="mb-0 pb-0 text-[#6E7191]">
					{{
						type == 1
							? ('ORGANIZATION.BRANCH.BRANCH_NAME' | translate)
							: ('STORE.STORE_PROFILE.STORE_NAME' | translate)
					}}
					<span *ngIf="!branchInformationData?.name" class="text-[#7e2eb3]"
						>*</span
					>
				</p>
				<p class="viewMode">{{ this.branchInformationData?.name }}</p>
			</div>

			<!-- city -->
			<mat-form-field
				*ngIf="editInfoMode"
				[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
				class="w-full mr-3 rtl:ml-3 rtl:mr-0"
				appearance="outline"
			>
				<mat-label>{{ 'GENERAL_LABELS.CITY' | translate }}</mat-label>
				<mat-select
					class="w-auto rtl:ml-3 ltr:mr-3 px-2"
					[ngClass]="!editInfoMode ? 'text-[#6E7191]' : 'text-[#4E4B66]'"
					formControlName="cityId"
					required
					[compareWith]="compareWith"
					(valueChange)="countryChange($event)"
				>
					<mat-option class="text-xs" disabled="true"
						>{{ 'GENERAL_LABELS.SELECT_CITY' | translate }}*</mat-option
					>
					<mat-option *ngFor="let city of cities" [value]="city?.id">
						{{
							translate.currentLang == 'ar' ? city?.name?.ar : city?.name?.en
						}}
					</mat-option>
				</mat-select>
				<mat-error *ngIf="getController('cityId')?.valid">
					<validation-message
						[controller]="getController('cityId')"
						controller_name="GENERAL_LABELS.CITY"
					>
					</validation-message>
				</mat-error>
			</mat-form-field>
			<p
				*ngIf="editInfoMode && branchInformationData?.hasAppointments"
				class="py-0 pb-1 mt-0 my-3"
			>
				{{ 'ORGANIZATION.ORGANIZATION_STATUS.CHANGE_CITY_HINT' | translate }}
			</p>
			<div
				*ngIf="!editInfoMode"
				class="w-full h-[73px] p-[17px] border-solid border-b-2"
			>
				<p class="mb-0 pb-0 text-[#6E7191]">
					{{ 'GENERAL_LABELS.CITY' | translate }}
					<span
						*ngIf="!branchInformationData?.city?.name?.en"
						class="text-[#7e2eb3]"
						>*</span
					>
				</p>
				<p class="viewMode">
					{{ this.branchInformationData?.city?.name?.en }}
				</p>
			</div>
			<!-- main branch status -->
		</form>

		<div>
			<form [formGroup]="contactInfoForm">
				<div>
					<!-- Mobile Number -->
					<app-mobile-number
						*ngIf="editInfoMode"
						[isEditMode]="editInfoMode"
						[mobileNumbers]="branchInformationData?.mobileNumbers"
						[validateNumbers]="isContactDataValid?.mobileNumbers"
						[country]="branchInformationData?.country"
						[required]="true"
						(emitMobiles)="
							getContactController('mobileNumber')?.setValue($event?.mobiles);
							isMobileValid = $event?.isValid
						"
					></app-mobile-number>

					<ng-container *ngIf="!editInfoMode" class="">
						<div
							class="text-[#6E7191] w-full h-[73px] p-[17px] border-solid border-b-2"
							*ngFor="
								let mobile of branchInformationData?.mobileNumbers;
								let i = index
							"
						>
							<p class="mb-0 pb-0">
								{{
									(i == 0
										? 'GENERAL_LABELS.MOBILE_NUMBER'
										: i == 1
										? 'GENERAL_LABELS.SECOND_MOBILE_NUMBER'
										: 'GENERAL_LABELS.THIRD_MOBILE_NUMBER'
									) | translate
								}}
							</p>
							<p class="viewMode">
								{{ !mobile.phoneCode.includes('+') ? '+' : '' }}
								{{ mobile.phoneCode }}{{ mobile.mobileNumber }}
							</p>
						</div>
					</ng-container>
					<div
						*ngIf="
							!editInfoMode && branchInformationData?.mobileNumbers?.length == 0
						"
					>
						<div
							*ngIf="!editInfoMode"
							class="w-full h-[73px] p-[17px] border-solid border-b-2"
						>
							<p class="mb-0 pb-0 text-[#6E7191]">
								{{ 'GENERAL_LABELS.MOBILE_NUMBER' | translate }}
							</p>
							<p class="viewMode"></p>
						</div>
					</div>
					<!-- land line -->
					<mat-form-field
						*ngIf="editInfoMode"
						[dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
						class="w-full {{
							!isContactDataValid?.isLandlineUnique
								? 'ng-invalid mat-form-field-invalid'
								: ''
						}}"
						appearance="outline"
					>
						<mat-label>{{ 'GENERAL_LABELS.LAND_LINE' | translate }}</mat-label>
						<input
							#phoneInput
							formControlName="landline"
							type="text"
							matInput
							[maxlength]="
								branchInformationData?.city?.name?.en == 'Alexandria' ? 9 : 10
							"
							placeholder="{{ 'GENERAL_LABELS.LAND_LINE' | translate }}"
							[ngClass]="!editInfoMode ? 'text-[#6E7191]' : 'text-[#4E4B66]'"
						/>
						<img
							*ngIf="getContactController('landline')?.value && editInfoMode"
							(click)="getContactController('landline')?.setValue('')"
							class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
							src="./assets/images/close-square.svg"
							alt=""
						/>
						<mat-error>
							<validation-message
								[controller]="getContactController('landline')"
								controller_name="landline"
								pattern_Message="VALIDATION.PHONE"
							>
							</validation-message>
						</mat-error>
					</mat-form-field>
					<mat-error>
						<small
							class="mb-3 block"
							style="margin-top: -2rem"
							*ngIf="!isContactDataValid?.isLandlineUnique && editInfoMode"
							>{{ isContactDataValid?.uniqueLandLineErrorMessage }}</small
						>
					</mat-error>
					<mat-error>
						<small
							class="mb-3 block"
							*ngIf="showContactMessage && editInfoMode"
							>{{ 'VALIDATION.BRANCH_CONTACT' | translate }}</small
						>
					</mat-error>
					<div
						*ngIf="!editInfoMode"
						class="w-full h-[73px] mb-[17px] p-[17px] border-solid border-b-2"
					>
						<p class="mb-0 pb-0 text-[#6E7191]">
							{{ 'GENERAL_LABELS.LAND_LINE' | translate }}
						</p>
						<p class="viewMode">{{ this.branchInformationData?.landline }}</p>
					</div>
					<div class="ltr:ml-6 rtl:mr-6 mb-6">
						<mat-checkbox
							[checked]="getController('isMain')?.value"
							[disabled]="!editInfoMode"
							class="text-medium-gray max-mobile:mb-3"
						>
							{{ 'ORGANIZATION.BRANCH_DETAILS.SET_MAIN_BRANCH' | translate }}
						</mat-checkbox>
					</div>

					<div class="flex justify-end gap-3">
						<!-- cancel button  -->
						<button
							*ngIf="editInfoMode"
							(click)="changeEditMode(); initBasicInformationValues()"
							class="border border-solid border-[#D9DBE9] hover:bg-gradient hover:text-off-white mx-2 text-dark-grey"
							mat-button
						>
							{{ 'ACTIONS.CANCEL' | translate }}
						</button>
						<!-- submit button  -->
						<button
							*ngIf="editInfoMode"
							[disabled]="
								basicInfoForm?.invalid ||
								!isDataValid ||
								!isContactDataValid?.isInfoValid ||
								!isMobileValid ||
								contactInfoForm?.invalid
							"
							(click)="changeNameConfirmation()"
							class="bg-gradient text-white"
							mat-button
						>
							{{ 'ACTIONS.SAVE' | translate }}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>
